//GLOBAL 
export const NEXTBTN_IS_CHECKED = 'NEXTBTN_IS_CHECKED';
export const CONFIRMBTN_IS_CHECKED = 'CONFIRMBTN_IS_CHECKED';
export const UPDATE_PAGE_NUMBER = 'UPDATE_PAGE_NUMBER';

//PAHGE1
export const UPDATE_COUNTRY = 'UPDATE_COUNTRY';
export const UPDATE_CITY = 'UPDATE_CITY';
export const UPDATE_STORE = 'UPDATE_STORE';

// PAGE 2
export const UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT';
export const UPDATE_DATE = 'UPDATE_DATE';
export const UPDATE_ACTIVEDAY = 'UPDATE_ACTIVEDAY';
export const UPDATE_TIMESLOT = 'UPDATE_TIMESLOT';
export const UPDATE_ACTIVETIMESLOT = 'UPDATE_ACTIVETIMESLOT';
export const UPDATE_PERSONAL_INFORMATION = 'UPDATE_PERSONAL_INFORMATION';
